import GeneralTranslations from "../../../Common/ModuleTranslations/es";
import CONSTANTS from "../../constants";

function formTypeHelperText({ formValues }) {
  switch (formValues.type) {
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.RESERVATION_CONFIRMATION:
      return "Se envía cuando se confirma la reserva. Solo puede estar activa una plantilla al mismo tiempo.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.RESERVATION_STATUS_RED:
      return "Se envía cuando el pago de la reserva ha fallado.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.POST_STAY:
      return "Se envía días después de la estancia del huésped.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.PRE_STAY:
      return "Se envía días antes de la llegada del huésped.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.CART_ABANDONMENT:
      return "Se enviará el email si el huésped había iniciado sesión como usuario loyalty y tenía al menos una reserva en el carrito.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.GIFT_CARD:
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.PURCHASE_EVENT:
    default:
      return "";
  }
}

export default {
  locale: "es",
  name: "Plantillas de emails",
  translation: {
    displayName: "Traducciones",
  },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "active",
        displayName: "Activo",
      },
      {
        fieldName: "type",
        displayName: "Tipo de email",
      },
      {
        fieldName: "emailDestinationType",
        displayName: "Destinatario del email",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "Ticker de hotel",
      },
      {
        fieldName: "isActive",
        displayName: "Activo",
      },
      {
        fieldName: "type",
        displayName: "Tipo de Email",
        optionDisplay: {
          RESERVATION_CONFIRMATION: {
            label: "Confirmación de reserva",
          },
          RESERVATION_STATUS_RED: {
            label: "Pago fallido",
          },
          GIFT_CARD: {
            label: "Cheque regalo (con estancia)",
          },
          PURCHASE_EVENT: {
            label: "Cheque regalo (sin estancia)",
          },
          POST_STAY: {
            label: "Post-estancia",
          },
          PRE_STAY: {
            label: "Pre-estancia",
          },
          CART_ABANDONMENT: {
            label: "Abandono de carrito",
          },
        },
        transform: ({ field, userInfo, formValues }) => {
          const isWitAdmin = userInfo?.isWitAdmin;
          const extraOptions = isWitAdmin
            ? {
                RESERVATION_STATUS_ORANGE: {
                  label: "Proceso de pago abandonado",
                },
              }
            : {};
          return {
            ...field,
            optionDisplay: { ...field.optionDisplay, ...extraOptions },
            className: "negativeMargin",
            helpText: formTypeHelperText({ formValues }),
          };
        },
      },
      {
        fieldName: "delay",
        displayName: "Demora",
        optionDisplay: {
          5: {
            label: "5 minutos",
          },
          10: {
            label: "10 minutos",
          },
          15: {
            label: "15 minutos",
          },
          30: {
            label: "30 minutos",
          },
          45: {
            label: "45 minutos",
          },
          60: {
            label: "60 minutos",
          },
        },
        helpText: "Cantidad de tiempo después de la cual se envía el correo",
      },
      {
        fieldName: "delayCartAbandonment",
        displayName: "Demora",
        optionDisplay: {
          60: {
            label: "1 hora",
          },
          120: {
            label: "2 horas",
          },
          180: {
            label: "3 horas",
          },
          360: {
            label: "6 horas",
          },
          720: {
            label: "12 horas",
          },
          1440: {
            label: "24 horas",
          },
          2880: {
            label: "48 horas",
          },
        },
        helpText: "Tiempo después del abandono del carrito para enviar el email.",
      },
      {
        fieldName: "templateType",
        displayName: "Tipo de plantilla",
        optionDisplay: {
          DEFAULT: {
            label: "Plantilla default",
          },
          CUSTOM: {
            label: "Plantilla custom",
          },
        },
      },
      {
        fieldName: "singleMailOnMultipleRoomStays",
        description:
          "Para reservas múltiples agrupar confirmaciones en un solo email (Solo visible para WIT)",
      },
      {
        fieldName: "delayCheckout",
        displayName: "Días posteriores al check-out para el envío",
      },
      {
        fieldName: "delayCheckin",
        displayName: "Días previos al Check-in para el envío",
      },
      {
        fieldName: "chronoUnit",
        displayName: "Delay units",
        optionDisplay: {
          MINUTES: {
            label: "Minutes",
          },
          HOURS: {
            label: "Hours",
          },
          DAYS: {
            label: "Days",
          },
        },
      },
      {
        fieldName: "emailDestinationType",
        displayName: "Destinatario del email",
        optionDisplay: {
          ALL: {
            label: "Todos",
          },
          GUEST: {
            label: "Huéspedes",
          },
          PROPERTY: {
            label: "Establecimiento",
          },
        },
      },
      {
        fieldName: "emailGuestType",
        displayName: "Tipo de huesped",
        optionDisplay: {
          ALL: {
            label: "Todos",
          },
          LOYALTY_GUEST: {
            label: "Fidelizado",
          },
          NON_LOYALTY_GUEST: {
            label: "No fidelizado",
          },
        },
      },
      {
        fieldName: "subject",
        displayName: "Asunto",
      },
      {
        fieldName: "body",
        displayName: "Cuerpo",
      },
      {
        fieldName: "header",
        displayName: "Cabecera",
      },
      {
        fieldName: "footer",
        displayName: "Pie",
      },
    ],
  },
};
